import { render } from "./ZaiShouPeiPage.vue?vue&type=template&id=1cf96960&scoped=true"
import script from "./ZaiShouPeiPage.vue?vue&type=script&lang=js"
export * from "./ZaiShouPeiPage.vue?vue&type=script&lang=js"

import "./ZaiShouPeiPage.vue?vue&type=style&index=0&id=1cf96960&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf96960"]])

export default __exports__